import Warning from './Warning.vue';

export default Warning;



// WEBPACK FOOTER //
// ./src/pages/profile/components/warning/index.ts